// Screenname:Group master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages:
import httpbaseURL from "../common/axios";
class ApprovalHistoryservices {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/ApprovalHistory/Create", doc);
  }
  getdata() {
    return httpbaseURL.httpMSInventoryUrl.get("/ApprovalHistory/List");
  }
  GetPOApprovalList(doc, OrganizationId, BranchId, EntityId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/ApprovalHistory/GetPOApprovalList?id=" +
        doc +
        "&OrganizationId=" +
        OrganizationId +
        "&BranchId=" +
        BranchId +
        "&EntityId=" +
        EntityId +
        ""
    );
  }
  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/ApprovalHistory/Update", doc);
  }
  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/ApprovalHistory/Delete?id=" + doc
    );
  }
  POApproval(doc) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.post(
      "ApprovalHistory/UpdateApprovalHistory",
      doc
    );
  }
  POReject(doc) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.post("ApprovalHistory/POReject", doc);
  }
  GetPOApprovalEntityOperationId(EntityId, Approval, Reject, OrganizationId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/ApprovalHistory/POApprovalEntityOperationId?EntityId=" +
        EntityId +
        "&Approval=" +
        Approval +
        "&Reject=" +
        Reject +
        "&OrganizationId=" +
        OrganizationId +
        ""
    );
  }
}
export default new ApprovalHistoryservices();
